import Sidebar from "../layout/Sidebar";
import Topbar from "../layout/Topbar";
import JobReportsContentnew from "../components/JobReportsContentnew";
import { useState } from "react";

function JobReports() {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="app">

      {/* Sidebar */}
      <Sidebar
        show={showSidebar}
        closeSidebar={() => setShowSidebar(false)}
      />

      {/* Main */}
      <div className="main">
        <Topbar toggleSidebar={() => setShowSidebar(true)} />

        <div className="page">
          <JobReportsContentnew />
        </div>
      </div>
    </div>
  );
}

export default JobReports;